import React from "react";
import { Table } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useHistory } from "react-router-dom";
import {
    ACTION_TEXT,
    ACTIVITY_TITLE_TEXT,
    COMPLETED_ACTIVITIES_DESCRIPTION,
    COMPLETED_ACTIVITIES_TEXT,
    GRADE_BOOK_TEXT,
    NO_COMPLETED_ACTIVITIES,
    POLL_STATUS_HEADER,
    POLL_TYPE,
    SHARED_ENTIRELY,
    TEXTBOX,
} from "../../utils/constants";
import {getPollStatus, removePrefixNew} from "../../utils/helpers";
import styles from "./DashboardPage.module.css";
import { ReactComponent as RecentResultIcon } from "./images/gradient_table_icon.svg";
import { ReactComponent as NoResultIllustration } from "../../images/no_result.svg";
import {Button} from "@base-ui/react/button";

export default function DashboardCardCompletedActivities({data=[], loading=true}) {
    const history = useHistory();
    // const [selectedIndex, setSelectedIndex] = useState([]);

    const viewResult = (poll) => {
        const {pollKey, pollSortKey, pollType=POLL_TYPE.GRADED_POLL} = poll;
        history.push({
            pathname: "/gradebook",
            state : {
                pollKey : removePrefixNew(pollKey),
                uniqueCode: removePrefixNew(pollSortKey),
                pollType: pollType,
            }
        });
    }

    if (loading) {
        return (
            <div style={{flex: 1, height: 350}}>
                <Skeleton borderRadius={10} height={"100%"} width={"100%"}/>
            </div>
        );
    }

    return (
        <div className={styles.panelContainer} style={{display: "flex", flexDirection: "column", flex: 1}}>
            <div className={styles.panelTitle}>
                <RecentResultIcon style={{marginRight: "15px", flexShrink: 0, width: 18, height: 18}}/>
                <div>{COMPLETED_ACTIVITIES_TEXT}</div>
            </div>

            <div className={styles.panelBody}>
                {(!data || !data.length) &&
                    <>
                        <div style={{flex: 1}}/>
                        <NoResultIllustration style={{maxWidth: "100%", maxHeight: "100%", marginRight: "15px"}}/>
                        <span className={styles.noResultTitle} style={{marginTop: 40}}>
                            {NO_COMPLETED_ACTIVITIES}
                        </span>
                        <span className={styles.noResultDescription}>
                            {NO_COMPLETED_ACTIVITIES}
                        </span>
                        <div style={{flex: 1}}/>
                    </>
                }
                {(!!data && !!data.length) &&
                    <>
                        <div className={styles.panelDescription} style={{alignSelf: "start"}}>
                            {COMPLETED_ACTIVITIES_DESCRIPTION}
                        </div>
                        <div className={styles.tableWrapper}>
                            <Table className={styles.recentResultTable} hover>
                                <thead>
                                <tr>
                                    <th style={{width: 200, minWidth: 0, textAlign: "left"}}>
                                        {ACTIVITY_TITLE_TEXT}
                                    </th>
                                    <th style={{width: 180, minWidth: 0}}>{POLL_STATUS_HEADER}</th>
                                    <th style={{width: 120, minWidth: 0,}}>{ACTION_TEXT}</th>
                                </tr>
                                </thead>
                                <tbody>
                                {JSON.parse(JSON.stringify(data)).splice(0, 5).map((poll, index) => {
                                    let pollStatus = getPollStatus(poll);
                                    let badgeClass = pollStatus === SHARED_ENTIRELY ? styles.releaseEntirely : styles.releaseSingle;

                                    return (
                                        <tr key={index} style={{cursor: "pointer"}} onClick={() => viewResult(poll)}>
                                            <td  className={styles.omitableText}
                                                style={{textAlign: "left"}}>{poll.pollTitle}</td>
                                            <td>
                                                <div style={{display: "flex"}}>
                                                    <span className={`${styles.badge} ${badgeClass}`}
                                                          style={{width: 180}}>
                                                       {pollStatus}
                                                    </span>
                                                </div>
                                            </td>
                                            <td >
                                                <div style={{display: "flex"}}>
                                                <Button
                                                    className={styles.gradientButton}
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        viewResult(poll);
                                                    }}
                                                >
                                                    {GRADE_BOOK_TEXT}
                                                </Button>
                                                </div>
                                            </td>
                                        </tr>
                                    );

                                })}
                                </tbody>
                            </Table>
                        </div>
                    </>

                }
            </div>
        </div>
    );
}